import {useMemo} from 'react'

import {useRefetchableLazyLoadQuery} from '../../../../hooks/relay/useRefetchableLazyLoadQuery'
import useInterval from '../../../../hooks/useInterval'
import type {BuildId} from '../../../../types'
import {emptyArray} from '../../../../utils/empty'

import type {WaitReasonsListQuery} from './__generated__/WaitReasonsListQuery.graphql'
import {query} from './WaitReasonsList.queries'

const MILLISECONDS_IN_SECOND = 1000

export function useWaitReasons(buildId: BuildId, interval: number | null) {
  const [{build}, refetch] = useRefetchableLazyLoadQuery<WaitReasonsListQuery>(query, {
    buildLocator: `id:${buildId}`,
  })
  useInterval(refetch, interval)
  const properties = build?.queuedWaitReasons?.property ?? emptyArray
  return useMemo(
    () =>
      properties.map(({name = '', value}) => ({
        reason: name,
        durationInSeconds: Number(value) / MILLISECONDS_IN_SECOND,
      })),
    [properties],
  )
}
